import { camelCase } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertToCamelCase: any = (
  obj: { [x: string]: any; map?: void; constructor?: any } | null,
) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => convertToCamelCase(v));
  }
  if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: convertToCamelCase(obj[key]),
      }),
      {
      },
    );
  }
  return obj;
};
